import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router/router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authenticated: false,
		user: {
			keepLogged: false,
			token: undefined,
		},
		alertMessage: undefined,
		alertType: undefined,
		rules: {
			required: (v) => !!v || 'Requerido',
			min2: (v) => (!!v && v.length > 2) || 'Min 2 caracteres',
			max200: (v) => (!!v && v.length < 201) || 'Max 200 caracteres',
			cpf: (v) => (!!v && v.length == 14) || 'CPF incompleto',
			email: (v) => /.+@.+\..+/.test(v) || 'Digite um email válido',
			numero: (v) =>
				(!isNaN(v) && v >= 0 && v < 1000 && v % 1 === 0 && /^-?[0-9]+$/.test(v)) ||
				'Digite um número inteiro menor que mil',
		},
		XMLHttpRequest: true,
		money: {
			decimal: ',',
			thousands: '.',
			precision: 2
		}
  },
  mutations: {
		logInOut: (state, { user, authenticated }) => {
			state.user = user
			state.authenticated = authenticated
		},
		alert: (state, { alertMessage, alertType }) => {
			state.alertMessage = alertMessage
			state.alertType = alertType
		},
		user: (state, { value }) => {
			state.user = value
		},
		authenticated: (state, { value }) => {
			state.authenticated = value
		},
		XMLHttpRequest: (state, { value }) => {
			state.XMLHttpRequest = value
		},
  },
  actions: {
    logIn: ({ commit }, { user, authenticated }) => {
			commit('logInOut', {
				user: user,
				authenticated: authenticated,
			})
		},
		logOut: ({ commit }, { destination }) => {
			commit('logInOut', {
				user: {
					keepLogged: false,
					token: undefined,
				},
				authenticated: false,
			}),
				router.push({
					name: 'Login',
					query: { redirect: destination },
				})
		},
		alert: ({ commit }, { alertMessage, alertType }) => {
			commit('alert', {
				alertMessage: alertMessage,
				alertType: alertType,
			})
		},
		errorServer: ({ dispatch }, { data, destination }) => {
			if (data.error === 1) {
				dispatch('alert', {
					alertMessage: data.alertMessage,
					alertType: data.alertType,
				})
			} else if (data.error === 2) {
				dispatch('logOut', { destination: destination })
			}
		},
		authenticated: ({ commit }, { value }) => {
			commit('authenticated', {
				value: value,
			})
		},
		user: ({ commit }, { value }) => {
			commit('user', {
				value: value,
			})
		},
		XMLHttpRequest: ({ commit }, { value }) => {
			commit('XMLHttpRequest', {
				value: value,
			})
		},
  },
  getters: {
		isMobileDevice: () => {
			return (
				typeof window.orientation !== 'undefined' ||
				navigator.userAgent.indexOf('IEMobile') !== -1
			)
		},
	},
})
